import { Action, createReducer, on } from '@ngrx/store';
import * as support from '../actions/support';

export interface State {
  sport: string;
}

const initialState: State = {
  sport: 'football'
};

export const supportReducer = createReducer(
  initialState,
  on(support.ToggleSupportPageAction, (state, action) => {
    return Object.assign({}, state, { sport: action.payload });
  })
);

export function reducer(state: State | undefined, action: Action): State {
  return supportReducer(state, action);
}

export const getSport = (state: State) => state.sport;
export const isFootball = (state: State) => state.sport === 'football';
export const isSoccer = (state: State) => state.sport === 'soccer';
